module.exports = __webpack_public_path__ + "img/moving.90a5cd77.gif";